import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import GiftCodeForm from './GiftCodeForm'
import { userHasCardOnFile } from './'
import './GiftCodeModal.less'

function GiftCodeModal ({ user, userActions }) {
  const history = useHistory()
  const hasCard = !!userHasCardOnFile(user)

  const handleCodeValidated = ({ code, productName, valid }) => {
    if (valid) {
      // Always redirect to checkout with validated subscription
      const subscription = productName || 'awn-plus-account-yearly'

      // Close modal first to avoid visual glitches
      userActions.doModal(null)

      // Then navigate to checkout
      history.push(`/subscriptions/checkout?subscription=${subscription}&code=${code}&redeemCode=true`)
    }
  }

  const handleCancel = () => {
    userActions.doModal(null)
  }

  return (
    <div className='payment-gift-code-modal'>
      <h2>AWN+ Gift Code</h2>
      {hasCard && (
        <p className='subtitle'>
          Enter your code to activate a 1 year free AWN+ plan or apply a discount to your subscription.
        </p>
      )}
      <GiftCodeForm
        user={user}
        onCodeValidated={handleCodeValidated}
        onCancel={handleCancel}
      />
    </div>
  )
}

GiftCodeModal.propTypes = {
  user: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired
}

GiftCodeModal.displayName = 'GiftCodeModal'

export default GiftCodeModal
